import * as angular from 'angular';
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import {apsEnums} from "../../shared/dto/aps.enums";
import {apsCommon} from "../../shared/dto/aps.common";

import AuthDataServiceName, {AuthDataService} from "./authData.service";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";
import {NavigationModel} from "../../models/navigation";

export interface AuthService {
  isAuthenticated(): boolean;

  login(username: string, password: string, code?: string): angular.IPromise<any>;
  logoff(navigation: NavigationModel): void;
  setRoleLocation(role?: any, plant?: any, shop?: any, shift?: apsEnums.Shift): angular.IPromise<any>;
  getUserData(): angular.IPromise<apsViewModels.UserData>;
}

export default angular.module('aps.services.auth', [HttpServiceName, AuthDataServiceName])
  .service('authService',
    function($q: angular.IQService,
             $window: any,
             httpService: HttpService,
             authDataService: AuthDataService) {

      function login(username, password, code) {
        let request = 'grant_type=password' +
          '&username=' + encodeURIComponent(username) +
          '&password=' + encodeURIComponent(password);

        if(code !=null )
          request = request + '&scope='+ code;

        return httpService.postRequest(Endpoints.POST_TOKEN, {
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          data: request
        })
          .then(function(data: any) {
            authDataService.setUserId(data.userId);
            /* tslint:disable:no-string-literal */
            authDataService.setToken(data['access_token']);
            /* tslint:enable:no-string-literal */
            return httpService.get(Endpoints.USER_ROLES).then((roles: apsCommon.UserRolePlants[]) => {
              authDataService.setRoles(roles);
            });
          });
      }

      function getUserData(): angular.IPromise<apsViewModels.UserData> {
        let data = authDataService.getUserData();
        if (data) {
          return $q.when(data);
        }
        let roleLocation = authDataService.getSelectedRoleLocation();
        if (!roleLocation) {
          return $q.when(undefined);
        }
        return httpService.get(Endpoints.USER_DATA, {
          roleId: roleLocation.role.roleId,
          plantId: roleLocation.plant ? roleLocation.plant.id : ''
        }).then((userData: apsViewModels.UserData) => {
          authDataService.setUserData(userData);
          return userData;
        });
      }

      function logoff(navigation: NavigationModel) {
        if (navigation) {
          navigation.uninitialize();
        }
        authDataService.clearToken();
        authDataService.clearSelectedRoleLocation();
        authDataService.clearUserData();
        authDataService.clearUserId();
      }

      function isAuthenticated() {
        return authDataService.getToken() !== undefined;
      }

      function setRoleLocation(role, plant, shop, shift?: apsEnums.Shift) {
        return httpService.post(Endpoints.USER_ROLE_LOCATION, {
          roleId: role.roleId,
          plantId: (plant || {}).id,
          shopId: (shop || {}).id,
          shift: shift
        }).then(() => {
          authDataService.setSelectedRoleLocation(role, plant, shop);
        });
      }

      return {
        login: login,
        logoff: logoff,
        isAuthenticated: isAuthenticated,
        setRoleLocation: setRoleLocation,
        getUserData: getUserData
      };
    }).name;


// WEBPACK FOOTER //
// ./src/app/services/auth/auth.service.ts